import type { CloudType } from "../types/api";

// API Configuration
export const API_CONFIG = {
  // API endpoints for graph data
  ENDPOINTS: {
    USER_NODES: "/api/cloud/get-user-nodes",
    SERVICE_ACCOUNT_NODES: "/api/cloud/get-service-account-nodes",
    RESOURCE_NODES: "/api/cloud/get-resource-nodes",
    ALERT_NODES: "/api/cloud/get-alert-nodes",
    ROLE_NODES: "/api/cloud/get-role-nodes",
    USER_EDGES: "/api/cloud/get-user-edges",
    NHI_EDGES: "/api/cloud/get-nhi-edges",
    RESOURCE_EDGES: "/api/cloud/get-resource-edges",
    ANOMALY_EDGES: "/api/cloud/get-alert-edges",
    QUERY_RESULTS: "/api/cloud/get-query-results",
  },

  // Cloud account list endpoints
  CLOUD_ENDPOINTS: {
    TENANTS: "/api/get-all-domains",
    GCP_PROJECTS: "/api/gcp/auth/fetchAllProjectIds",
    AWS_ACCOUNTS: "/api/aws/getAllAccounts",
    AZURE_SUBSCRIPTIONS: "/api/azureResources/v1/all",
  },
};

// Default request parameters
export const DEFAULT_PARAMS = {
  tenantName: "default-tenant",
  cloudId: "default-cloud-id",
  cloudType: "GCP" as CloudType,
};
